import { useEffect, useState } from "react";

const BUSY = ["/daily", "/farm", "/challenge", "/checkout", "/payment"];

export default function UpdatePrompt() {
  const [waiting, setWaiting] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    let reg; let alive = true;
    const onWorker = (w) => { if (!w) return; if (w.state === "installed") { if (navigator.serviceWorker.controller) setWaiting(w); return; } w.addEventListener("statechange", () => { if (w.state === "installed" && navigator.serviceWorker.controller && alive) setWaiting(w); }); };
    navigator.serviceWorker.ready.then(r => {
      if (!alive) return; reg = r;
      onWorker(reg.waiting || reg.installing);
      reg.addEventListener("updatefound", () => onWorker(reg.installing));
    }).catch(() => {});
    const check = () => reg?.update().catch(() => {});
    const id = setInterval(check, 15 * 60 * 1000);
    const vis = () => document.visibilityState === "visible" && check();
    document.addEventListener("visibilitychange", vis); window.addEventListener("focus", vis);
    let refreshing = false;
    const onCtrl = () => { if (refreshing) return; refreshing = true; window.location.reload(); };
    navigator.serviceWorker.addEventListener("controllerchange", onCtrl);
    return () => { alive = false; clearInterval(id); document.removeEventListener("visibilitychange", vis); window.removeEventListener("focus", vis); navigator.serviceWorker.removeEventListener("controllerchange", onCtrl); };
  }, []);
  if (!waiting || dismissed) return null;
  if (BUSY.some(p => window.location.pathname.startsWith(p))) return null;
  const update = () => { waiting.postMessage("SKIP_WAITING"); setTimeout(() => window.location.reload(), 2500); };
  return (
    <div role="status" className="fixed left-3 right-3 md:left-auto md:right-6 md:w-96 z-[55] rl-card p-4 shadow-2xl" style={{ bottom: "calc(env(safe-area-inset-bottom) + 84px)" }} data-testid="pwa-update">
      <div className="font-display font-bold text-sm mb-1">È DISPONIBILE UN AGGIORNAMENTO DI RALLY LOVE</div>
      <div className="text-xs text-slate-400 mb-3">Nessun dato o progresso verrà perso.</div>
      <div className="flex gap-2"><button className="btn-crimson !py-2 !px-4 text-xs min-h-[44px]" onClick={update} data-testid="pwa-update-now">AGGIORNA ORA</button><button className="btn-outline-rl !py-2 !px-4 text-xs min-h-[44px]" onClick={() => setDismissed(true)} data-testid="pwa-update-later">PIÙ TARDI</button></div>
    </div>
  );
}
